<template>
  <transition name="modal">
    <div v-if="showing" class="v-multi-modal min-h-screen fixed inset-0 overflow-y-auto" role="dialog" aria-modal="true">
      <transition-group name="modal"><slot /></transition-group>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { toRef } from 'vue'

const props = defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
})

usePreventBodyScroll({ shouldStopScroll: toRef(props, 'showing') })
</script>

<style lang="stylus" scoped>
.modal-enter-active
  @apply ease-out duration-300

.modal-leave-active
  @apply ease-in duration-200
</style>
